import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth, { IDToken } from '@okta/okta-auth-js';
import { UserClaims } from 'src/app/model/okta/userClaims';
import { EncryptionService } from './encryption.service';
import { JwtHelperService } from './jwthelper.service';
import { StorageService } from './storage.service';
@Injectable({
	providedIn: 'root',
})
export class PGHOktaService {
	originalToken: string;

	constructor(
		@Inject(OKTA_AUTH) private oktaAuth: OktaAuth
	) {}

	getIdToken(): IDToken {
		const tokendata = localStorage.getItem('okta-token-storage');
		if (tokendata) {
      const parsedToken = JSON.parse(tokendata);
      if(parsedToken.hasOwnProperty("id_token"))
        return parsedToken['id_token'];
      if(parsedToken.hasOwnProperty("idToken"))
        return parsedToken['idToken'];
      return null;
		} else {
      return null;
		}
	}

  getAccessToken(): string {
		const tokendata = localStorage.getItem('okta-token-storage');
		if (tokendata) {
      const parsedToken = JSON.parse(tokendata);
			return parsedToken?.access_token?.accessToken ?? parsedToken?.accessToken?.accessToken
		} else {
      return null;
		}
	}

	isTokenValid() {
		let jwtHelperService = new JwtHelperService();
		let token = this.getIdToken();
		if (token === null) {
			return false;
		}
		if (jwtHelperService.isTokenExpired(token)) {
			return false;
		} else {
			return true;
		}
	}

	async getUser() : Promise<UserClaims | null> {
		if (this.isTokenValid()) {
      let user: UserClaims | null = null;
      if (localStorage.getItem('okta-user')) {
		// try getting latest one from Okta service to see if it fixes the PGH APP issue.
		user = await this.oktaAuth.getUser();
        // user = JSON.parse(localStorage.getItem('okta-user'));
        return user;
      } else {
        user = await this.oktaAuth.getUser();
        localStorage.setItem('okta-user', JSON.stringify(user));
        return user;
      }
    }
	}
}
